import { GAME_ID, REDUX_ACTIONS } from 'a/sortItOut/data/constants';

export const initialState = {
  questions: [],
  categories: [],
  currentItem: null,
  questionsAnswered: 0,
  hiddenCategory: null,
  selectedCategory: null,
  highlightedCategory: null,
  audioCategory: null,
  interactionLocked: false,
};

const practiceReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.INIT_ROUND:
      return { ...initialState };
    case REDUX_ACTIONS.ADD_PRACTICE_QUESTION: {
      const questions = state.questions.slice();
      questions.push(action.payload.question);

      return {
        ...state,
        questions,
      };
    }
    case REDUX_ACTIONS.START_PRACTICE:
      return {
        ...state,
        currentItem: state.questions[0],
        categories: state.questions[0].categories,
      };
    case REDUX_ACTIONS.NEXT_PRACTICE_ITEM:
      return {
        ...state,
        currentItem: state.questions[state.questionsAnswered],
        categories: state.questions[state.questionsAnswered].categories,
        hiddenCategory: null,
        selectedCategory: null,
        highlightedCategory: null,
      };
    case REDUX_ACTIONS.INCREMENT_PRACTICE_QUESTIONS_ANSWERED:
      return {
        ...state,
        questionsAnswered: state.questionsAnswered + 1,
      };

    case REDUX_ACTIONS.SET_HIDDEN_CATEGORY:
      return {
        ...state,
        hiddenCategory: action.payload.hiddenCategory,
      };
    case REDUX_ACTIONS.SET_AUDIO_CATEGORY:
      return {
        ...state,
        audioCategory: action.payload.audioCategory,
      };
    case REDUX_ACTIONS.SET_SELECTED_CATEGORY:
      return {
        ...state,
        selectedCategory: action.payload.selectedCategory,
      };
    case REDUX_ACTIONS.SET_HIGHLIGHTED_CATEGORY:
      return {
        ...state,
        highlightedCategory: action.payload.highlightedCategory,
      };
    case REDUX_ACTIONS.SET_PRACTICE_INTERACTION_LOCKED:

      return {
        ...state,
        interactionLocked: action.payload.interactionLocked,
      };
    default:
      return state;
  }
};

export default practiceReducer;
